// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1USLE","top":"styles_top__3NUoa","left":"styles_left__23r2U","description":"styles_description__1sWES"};